<template>
  <div id="home_content">
    <div class="container-md">
      <i-navbar></i-navbar>

      <!-- header -->
      <header>
        <div class="row">
          <div id="empty" class="col-6"></div>
          <div id="news" class="col-6">
            <div class="row">
              <div class="col text-left">
                <span>【最新消息】</span>
              </div>
              <div class="col text-right">
                <span id="#visit_span">瀏覽人次：{{ visit_nums }}</span>
              </div>
            </div>
            <div class="row mt-2">
              <div id="news_content" class="col">
                <ul>
                  <li
                    class="py-1 px-2 text-left"
                    v-for="item in sliceNews"
                    :key="item.news"
                  >
                    <a :href="item.link" target="_blank">{{ item.news }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row text-right">
              <div class="col">
                <a id="more_span" href="#" @click.prevent="getSliceNews(false)"
                  >more...</a
                >
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>

    <!-- section -->
    <section id="person_desp">
      <div class="container-fluid">
        <div id="person_desp_div" class="container-md">
          <div class="row">
            <div id="person_image" class="col-5">
              <img
                :src="
                  title_content_image_list[currTitleContentImageActiveIndex]
                    .image_url
                "
              />
            </div>
            <div class="col-7">
              <div class="row mt-5">
                <div id="person_title" class="col-10 text-left">
                  <span>葉德輝小傳</span>
                </div>
                <div id="font_size" class="col-2">
                  <a
                    href="#"
                    style="font-size: 20px"
                    :class="{ active: curr_font_size_active[0] }"
                    @click.prevent="setCurrFontSize(0, '20px')"
                    >A
                  </a>
                  <a
                    href="#"
                    style="font-size: 18px"
                    :class="{ active: curr_font_size_active[1] }"
                    @click.prevent="setCurrFontSize(1, '18px')"
                    >A
                  </a>
                  <a
                    href="#"
                    style="font-size: 16px"
                    :class="{ active: curr_font_size_active[2] }"
                    @click.prevent="setCurrFontSize(2, '16px')"
                    >A</a
                  >
                </div>
              </div>

              <div class="row mt-3">
                <div id="btn_section" class="col text-left">
                  <a
                    href="#"
                    class="btn mr-3"
                    :class="{ active: curr_title_active[0] }"
                    @click.prevent="setCurrTitleAndContent(0)"
                    >生平簡介</a
                  >
                  <a
                    href="#"
                    class="btn mr-3"
                    :class="{ active: curr_title_active[1] }"
                    @click.prevent="setCurrTitleAndContent(1)"
                    >藏書與治學</a
                  >
                  <a
                    href="#"
                    class="btn mr-3"
                    :class="{ active: curr_title_active[2] }"
                    @click.prevent="setCurrTitleAndContent(2)"
                    >圖書輯軼與出版</a
                  >
                </div>
              </div>

              <div class="row mt-3">
                <div id="person_intro_div" class="col text-left">
                  <p id="curr_title" :style="{ 'font-size': curr_font_size }">
                    ●
                    {{
                      title_content_image_list[currTitleContentImageActiveIndex]
                        .title
                    }}
                  </p>
                  <p
                    id="person_intro"
                    :style="{ 'font-size': curr_font_size }"
                    v-html="
                      title_content_image_list[currTitleContentImageActiveIndex]
                        .content
                    "
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- the third section -->
    <section id="book_desp">
      <div id="book_desp_div" class="container-md">
        <div class="row">
          <div id="book_image" class="col-6">
            <div>
              <img src="../assets/img/index-book-image.png" />
              <button
                type="button"
                class="btn rounded-circle"
                @click="openGame"
              >
                &nbsp;
              </button>
            </div>
            <div class="mt-3">
              <h5>愛「拼」才會贏 !</h5>
              <p>一起看看葉德輝的收藏與金句</p>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div id="book_content" class="col-8">
                <p>
                  《藏書十約》： <br />
                  「書不裝潢，則破葉斷線，觸手可<br />
                  厭。……裝釘不在華麗，但取堅致<br />
                  整齊。」<br />
                </p>
              </div>
              <div id="buddha_font_section" class="col-4">
                <img src="../assets/img/buddha_font.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- website_desp section -->
    <section>
      <div id="website_desp" ref="website_desp" class="container-md">
        <div class="row mt-5">
          <div id="website_desp_title" class="col-10 text-left">
            <span>網站說明</span>
          </div>
          <div id="font_size" class="col-2">
            <a
              href="#"
              style="font-size: 20px"
              :class="{ active: curr_website_font_size_active[0] }"
              @click.prevent="setCurrFontSize(0, '20px', 'website_desp')"
              >A
            </a>
            <a
              href="#"
              style="font-size: 18px"
              :class="{ active: curr_website_font_size_active[1] }"
              @click.prevent="setCurrFontSize(1, '18px', 'website_desp')"
              >A
            </a>
            <a
              href="#"
              style="font-size: 16px"
              :class="{ active: curr_website_font_size_active[2] }"
              @click.prevent="setCurrFontSize(2, '16px', 'website_desp')"
              >A</a
            >
          </div>
        </div>
        <div class="row mt-3">
          <div id="website_intro_div" class="col text-left">
            <p
              id="website_intro"
              :style="{ 'font-size': curr_website_font_size }"
              v-html="website_intro"
            ></p>
          </div>
        </div>
      </div>
    </section>

    <i-footer></i-footer>
  </div>
</template>

<script>
import navbar from '../components/Navbar.vue';
import footer from '../components/Footer.vue';

export default {
  mounted() {
    if (this.$route.path === '/website_desp') {
      this.$refs.website_desp.scrollIntoView();
    }

    const visitorCountAPI = `${process.env.VUE_APP_APIPATH}api/visit/1/`;
    this.$http.get(visitorCountAPI).then((response) => {
      this.visit_nums = `${response.data.times}`;
    });

    const newsAPI = `${process.env.VUE_APP_APIPATH}api/news/`;
    this.$http.get(newsAPI).then((response) => {
      const newsList = response.data;
      console.log(newsList);
      this.news = newsList;
      this.news.reverse();
      this.newsPageNums = Math.floor(this.news.length / 7) + 1;
      this.getSliceNews(true);
    });
  },
  components: {
    'i-navbar': navbar,
    'i-footer': footer,
  },
  data() {
    return {
      news: [],
      sliceNews: [],
      sliceNewsIndex: 0,
      newsPageNums: 0,
      visit_nums: '0000',
      currTitleContentImageActiveIndex: 0,
      title_content_image_list: [
        {
          title: '生平簡介',
          content:
            '<p>葉德輝（1864-1927），字煥彬，號郋園、直山，自署麗廔主人、避兵先生、朱亭山民，祖籍江蘇吳縣，清道咸間遷居湖南湘潭。光緒十八年壬辰科進士，科考後欽點為吏部主事，後因與部員論事不合，乞養還籍。此後則以圖書相伴，一心蒐購典籍、讀書著述與校勘出版。</p><p>葉德輝自幼心醉於《說文》之學，不僅以許慎故里所在地（汝南郋地）為號，又取《說文》「麗廔闓明」之義為其室名。</p>',
          image_url: `${process.env.VUE_APP_IMAGE_APIPATH}home/home_image_0.png`,
        },
        {
          title: '藏書與治學',
          content:
            '<p>葉德輝自年少時便喜愛四處尋訪圖書，不僅流連書肆，於北京科考期間，也時常前往隆福寺、琉璃廠一帶尋寶，此一雅癖橫亙葉德輝一生，所到之處皆留下其人探訪圖書的身影，故於《郋園讀書志序》自言：「竭四十年心力，凡四部要籍無不搜羅宏富，充棟連櫥」。葉德輝位於長沙的觀古堂藏書樓，更與道州何紹基的東洲草堂、湘潭袁芳瑛的臥雪廬、岳陽方功惠的碧琳琅館，並稱為湖湘四大藏書樓；又與北京著名藏書家傅增湘並稱「北傅南葉」。葉德輝除耗費重資購置圖書，也透過與其他藏書家之間的圖書交換、郵寄函購，或是商借珍貴藏本後影抄錄副等方式積累藏書。除蒐羅本國藏書外，葉德輝也透過與日籍友人的圖書交換，獲得早已在本國散失的圖書典籍，如自日本古籍《醫心方》輯佚之《素女經》、《玉房秘訣》、《玉房指要》、《洞玄子》四書便屬於此。其一生藏書數量，據蘇精《近代藏書三十家》所言，葉德輝一生所收藏的圖書約有超過三十萬卷的數量。</p><p>葉德輝的藏書理念乃是「為讀而藏」、「藏而能讀」，相較於其他藏書家以宋元為尊的傾向，葉德輝手中除少數宋元抄本外，則以明清刊刻書籍為重，亦重視近人精心校勘出版的著作，可知葉德輝所好者不僅是物質性的書籍載體，更重視其所承載的知識內容。葉德輝不僅將其閱覽書籍的札記匯整為《郋園讀書志》，又將其對刻書源流與書籍掌故的心得撰為《書林清話》與《書林餘話》，這兩部書籍則是奠定葉德輝身為版本目錄學家之作。此外，葉德輝又 將生平藏書心得撰寫為《藏書十約》一書，從書籍的購置、鑒別、裝潢、陳列、抄補、傳錄、校勘、題跋、收藏、印記十個方向切入，系統性的談論藏書的原則與方法。若從書籍的偏好類型觀之，則以經學、小學書籍為主，此點與葉德輝的學術傾向相連。葉德輝治《說文》之學四十餘年，撰有《六書古微》、《說文讀若字考》、《同聲假借字考》、《說文籀字考證》等書，日本學者松崎鶴雄前往中國留學之際，更特地前往長沙拜葉德輝為師，從其鑽研文字之學長達九年。</p>',
          image_url: `${process.env.VUE_APP_IMAGE_APIPATH}home/home_image_1.png`,
        },
        {
          title: '圖書輯軼與出版',
          content:
            '<p>葉德輝以傳古為己任，除藏書著述外，亦熱衷於圖書出版事業，自光緒18年（1982）輯刻《鬻子》開始，又在長沙思賢書局刻書處兼有職務，職此便利之故，陸續出版《觀古堂匯刻書》、《觀古堂所著書》、《麗廔叢書》、《石林遺書》、《觀古堂書目叢刻》等著作，對於古代典籍的保存與流傳，具有相當大的貢獻。葉德輝所校勘出版的圖書甚精，如由葉德輝校勘、全依宋本樣式摹刻附梓的《南嶽總勝集》幾可亂真，連於尋訪古書頗有見解的楊守敬，也曾受到書商矇騙，誤將葉德輝所摹刻者判定為宋本，足見葉德輝印刻書的精美。</p><p>葉德輝輯刻書籍的範圍十分廣泛，遍及經、子、史、集、宗教圖籍等各個領域，雖多屬於篇帙較小的典籍，仍可從中窺見葉德輝「稽古代作」的企圖，意即將藏書、校讎、輯佚、出版等事業化為橫貫一生的學術志業，又在書籍輯刻時融入個人生命際遇，展現出葉德輝以稽古出版替代立書著作的文化人姿態。</p><p>除經史典籍外，葉德輝亦雅好梨園，不僅仿照北京廣德樓戲園在長沙開闢劇場，也曾籌辦劇團同春班，並讓出部分宅院創設劇場同春園，同時自任為同春班與同春園的負責人。葉德輝所刊刻並收錄在《雙梅影闇叢書》中的《青樓集》、《燕蘭小譜》、《海漚小譜》、《秦雲擷英譜》，則是記載梨園優伶事蹟之作，日本學者鹽谷溫更是師從葉德輝研習中國戲曲，足見葉德輝於戲曲之道鑽研亦深。</p><p>愛書如命的葉德輝，曾言：「買書如買妾，美色看不厭。妾衰愛漸弛，書舊芳益烈。二者不可兼，得失心交接。有時妾專房，不如書滿篋。」、「買書勝買妾，書淫過漁色。朝夕與之倶，不聞室人謫。」又言：「書與老婆都不借」即可一窺葉德輝沉醉於書卷之間的癡迷樣態。</p><h2>參考資料</h2><p>1. 王逸明，李璞編著：《葉德輝年譜》，北京：學苑書版社，2012年。</p><p>2. 葉德輝：《消夏百一詩/觀畫百詠/遊藝卮言》，上海：華東師範大學出版社，2010年。</p><p>3. 印曉峰點校：《葉德輝詩集》，上海：華東師範大學出版社，2010年。</p><p>4. 金人：〈北傅南葉毀譽相參〉，《書屋》，2017年第11期，頁8-14。</p><p>5. 彭文靜：〈葉德輝及其藏書〉，《忻州師範學院學報》，2002年第01期，頁86-89。</p><p>6. 王晉卿：〈葉德輝的藏書思想與方法〉，《湘潭大學學報（哲學社會科學版）》，1996年第3期，頁112-118。</p><p>7. 張晶萍：〈葉德輝的閱讀活動及閱讀思想〉，《高校圖書館工作》，2017年第4期，頁28-31。</p><p>8. 胡文輝：《現代學林點將錄》，廣州：廣東人民出版社，2010年。</p><p>9.  劉苑如：〈從品鑑到借鑑──葉德輝輯刻《山公啟事》與閱讀〉，《中國文哲研究集刊》第38期（2011年3月），頁171-213。</p><p>10. 劉苑如：〈天化與人化──葉德輝星命學的知識建構與時代性〉，《儒學與古典學評論》第二期（2013年8月），頁68-90</p><p>11. 劉苑如：〈地獄版權：葉德輝印經因緣考〉，《清華中文學報》第11期（2014年6月），頁299-343。</p><p>12. 劉苑如：〈追憶真像／相——葉德輝與醜人自敘系譜〉，楊玉成、劉苑如主編：《今古一相接：中國文學的記憶與競技》，臺北：中央研究院中國文哲研究所，2019年9月，頁179-221。  </p><p>13.  劉苑如：〈衛生：葉德輝中西醫論述及其輯刻書〉，羅馬大學舉辦「人學與文學－－中國文化的兩度西潮國際研討會」論文集，2019年9月2 -3日，9頁。</p>',
          image_url: `${process.env.VUE_APP_IMAGE_APIPATH}home/home_image_2.png`,
        },
      ],
      curr_title_active: [1, 0, 0],
      curr_font_size: '18px',
      curr_font_size_active: [0, 1, 0],
      curr_website_font_size: '18px',
      curr_website_font_size_active: [0, 1, 0],
      website_intro:
        '<p>「葉德輝藏書閣──清末民初文人的知識圖譜平台」以晚清文人葉德輝的藏書閣出發，擴及清末民初重要藏書家和出版家葉昌熾、繆荃孫、江標等，從其經眼、收藏、校勘、輯佚、序跋、校注、彙編、出版書籍等活動，及所建構的「人─書─人」的交流網絡，探討古籍與新刊所構成的知識圖譜。作為科普性的學術研究網站，為兼顧一般讀者與文史研究者的需求，本站提供視覺展示與資料庫檢索：視覺展示上，從人物傳記、書籍資訊、行跡地圖、社會網絡、主題短文等方面，向大眾展現中國現代化知識建立的過程，以及新、舊時代人物碰撞、和解與相互影響的小故事；資料庫則是提供結構化的交叉檢索功能，期望協助專業讀者探索晚清文人與書籍的互動交流，發揮數位人文學（digital humanities）多元跨域與共做共享的研究精神。</p><p></p><p>本站接受科技部補助學術研究網站經費支持，奠基於科技部整合型專題研究計畫「葉德輝印刻書流通與人物往來的數位研究」（2015-2018年）之成果，進一步擴充而成，為中央研究院中國文哲所「滴水空明」數位人文空間所推出的第二個學術網站，在以葉德輝為核心的書籍流通過程中，其間蘊含各種「新」、「舊」的轉變，盼由此發枝散葉，回應時代感覺，進一步發掘同代與異代的研究議題。</p>',
    };
  },
  methods: {
    setCurrTitleAndContent(activeIndex) {
      this.curr_title_active = [0, 0, 0];
      this.curr_title_active[activeIndex] = 1;
      this.currTitleContentImageActiveIndex = activeIndex;
    },
    setCurrFontSize(activeIndex, fontSize, souceType) {
      if (souceType === 'website_desp') {
        this.curr_website_font_size = fontSize;
        this.curr_website_font_size_active = [0, 0, 0];
        this.curr_website_font_size_active[activeIndex] = 1;
      } else {
        this.curr_font_size = fontSize;
        this.curr_font_size_active = [0, 0, 0];
        this.curr_font_size_active[activeIndex] = 1;
      }
    },
    openGame() {
      window.open(
        'https://www.jigsawplanet.com/?rc=play&pid=1dcced7bd8e4',
        '_blank',
      );
    },
    getSliceNews(isInit) {
      if (isInit === false) {
        this.sliceNewsIndex += 1;
      }
      if (this.sliceNewsIndex >= this.newsPageNums) {
        this.sliceNewsIndex = 0;
      }
      const startIndex = this.sliceNewsIndex * 7;
      const endIndex = startIndex + 7;
      this.sliceNews = this.news.slice(startIndex, endIndex);
    },
  },
};
</script>

<style lang="sass" scoped>
$min-width: 1200px

#home_content
  background-color: #c2e3e3

header
  background-image: url('../assets/img/index-header-bg-image-v4.png')
  height: 100vh
  background-repeat: no-repeat
  background-size: 100%
  background-position: 90px 50px
  min-width: $min-width

#news
  padding-top: 100px
  div
    width: 70%
  ul
    padding-left: 0px
    list-style: none
    li
      margin-top: 1.5px
      border: 0.5px solid #ffffff
      background-color: #ffffff
      border-radius: 20px
      font-size: 14px
      letter-spacing: 1px
      color: black
      font-weight: 500
      font-family: "Microsoft Jheng Hei Light"
      opacity: 0.6
      &:hover
        filter: drop-shadow(3.536px 3.536px 2.5px rgba(0,0,0,0.4))

#visit_span
  font-size: 13px
  letter-spacing: 1px
  color: #636363
  font-weight: 300
  font-family: "Microsoft Jheng Hei Light"

#more_span
  color: #629697
  font-style: italic
  text-decoration: underline

#person_desp
  background-color: #ccf0f0
  height: 100vh

#person_desp_div
  min-width: $min-width

#person_title
  padding-left: 0px
  font-size: 20px
  letter-spacing: 2px
  line-height: 24px
  color: #106a8b
  font-weight: bold
  font-family: "Microsoft Jheng Hei Bold"
  border-bottom: 1px solid #5a8ca4

#person_image
  img
    width: 60%
    padding-top: 60px

#font_size
  color: #6b6a6a
  font-family: "Microsoft Jheng Hei Regular"

#btn_section
  padding-left: 0px
  a
    border-radius: 5px
    filter: drop-shadow(2.828px 2.828px 1.5px rgba(0,0,0,0.28))
    background-color: #b0b0b0
    font-size: 16px
    letter-spacing: 2px
    color: #ffffff
    font-family: "Microsoft Jheng Hei Regular"
  a.active
    filter: drop-shadow(2.828px 2.828px 1.5px rgba(0,0,0,0.28))
    background-color: #448087

#person_intro_div
  padding-left: 0px

#curr_title
  font-size: 16px
  letter-spacing: 1px
  line-height: 30px
  color: #106a8b
  font-family: "Microsoft Jheng Hei Regular"

#person_intro
  display: block
  height: 260px
  overflow-x: hidden
  overflow-y: auto
  font-size: 16px
  letter-spacing: 2px
  line-height: 30px
  color: #000000
  font-weight: 300
  font-family: "Microsoft Jheng Hei Light"

#font_size
  a.active
    border-radius: 15px
    background-color: #c2dada

#website_desp
  padding: 5rem 10rem
  min-width: $min-width

#website_desp_title
  border-bottom: 2px solid #5a8ca4
  padding-left: 0px
  span
    font-size: 20px
    letter-spacing: 2px
    line-height: 24px
    color: #106a8b
    font-weight: bold
    font-family: "Microsoft Jheng Hei Bold"

#book_desp_div
  min-width: $min-width

#book_image
  img
    padding-top: 50px
    margin-left: 5rem
  button
    position: absolute
    top: 71.5%
    left: 51.7%
    width: 45px
    height: 45px
  h5
    margin-left: 8rem
    font-weight: bold
    color: #106a8b
  p
    margin-left: 8rem

#book_content
  p
    writing-mode: vertical-rl
    display: block
    text-align: left
    padding-top: 7rem
    padding-left: 12rem
    font-size: 20px
    font-family: "標楷體"

#buddha_font_section
  img
    padding-top: 6rem

#website_intro_div
  margin-bottom: 15rem

#news_content
  height: 35vh
</style>
